module.exports = __webpack_public_path__ + "static/media/icon-checkbox-negative.308b2d7a.svg";